import {
  completeMagicLinkSignIn,
  getCurrentIdToken,
  getCurrentUser,
  onAuthStateChange,
  signInWithGoogle,
  signInWithMagicLink,
  signOutUser,
} from './auth/authService.ts';

export { getCurrentIdToken, getCurrentUser, signInWithGoogle };

export const sendSignInLink = signInWithMagicLink;
export const completeEmailSignIn = completeMagicLinkSignIn;
export const logout = signOutUser;
export const onAuthStateChanged = onAuthStateChange;
